export default __webpack_public_path__ + "static/article-renovation-easy-ways-to-add-character-to-your-home-66bec83a9aa45ab4281069b161c82f52.jpg";